import { createFetchAction, createRecordAction } from '../../utils';

export const devicesAssetsAction = {
  ...createFetchAction('devices-assets'),
  ...createRecordAction('devices-assets'),
};
